import type { GetRef, TourProps, TourStepProps } from 'antd';

import type { CSSProperties, ReactNode } from 'react';

export type PlacementType =
  | 'left'
  | 'leftTop'
  | 'leftBottom'
  | 'right'
  | 'rightTop'
  | 'rightBottom'
  | 'top'
  | 'topLeft'
  | 'topRight'
  | 'bottom'
  | 'bottomLeft'
  | 'bottomRight'
  | 'center';

export abstract class TourHelper {
  //create a tour step with the given parameters
  /**
   * Creates a tour step with the specified parameters.
   * @param title - The title of the tour step.
   * @param description - The description of the tour step.
   * @param placement - The placement of the tour step.
   * @param target - A function that returns the target element for the tour step.
   * @returns A TourProps object representing the tour step.
   */

  public static CreateTourSteps(
    t: Function,
    title: ReactNode,
    description: string,
    placement: PlacementType,
    target: HTMLElement,
  ) {
    var item: TourStepProps = {
      title: title,
      description: description,
      placement: placement,
      target: target,
      nextButtonProps: {
        children: t('next'),
      },
      prevButtonProps: {
        children: t('previous'),
      },
    };
    return item;
  }
}
